<template>
<ul class="exam-option" :class="mode">
  <li v-for="(item, index) in options" :key="item.serialNo" @click="tap(index, item.serialNo)"
      :class="{ on : item.checkFlag == 1 }">
    {{item.content}}
  </li>
</ul>
</template>

<script>
export default {
  props: ['mode', 'options'],
  methods: {
    tap (index, answer) {
      this.$emit('check', index, answer)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.exam-option {
  background-color: #fff;
  padding: 30px 30px 30px 90px;
  border-radius: 10px;
  > li {
    position: relative;
    color: $ucar_font_assist_color;
    &.on {
      color: $ucar_main_color;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: -60px;
      width: 34px;
      height: 34px;
      background: url("../assets/icon_radio.png") no-repeat 100%/100%;
      -webkit-background-size: contain;
      background-size: contain;
    }
    &.on::before{
      background: url("../assets/icon_radio_checked.png") no-repeat 100%/100%;
      -webkit-background-size: contain;
      background-size: contain;
    }
    & + li {
      margin-top: 30px;
      padding-top: 30px;
      border-top: 1px solid $ucar_light_border;
      &::before {
        top: 30px;
      }
    }
  }
  &.checkbox {
    > li {
      &::before {
        background: url("../assets/icon_checkbox.png") no-repeat 100%/100%;
        -webkit-background-size: contain;
        background-size: contain;
      }
      &.on::before{
        background: url("../assets/icon_checkbox_checked.png") no-repeat 100%/100%;
        -webkit-background-size: contain;
        background-size: contain;
      }
    }
  }
}
</style>